module.exports.HTTPGateway = require('./HTTPGateway');
module.exports.InfuraGateway = require('./InfuraGateway');
module.exports.InjectedGateway = require('./InjectedGateway');
module.exports.RivetGateway = require('./RivetGateway');
module.exports.XDaiGateway = require('./XDaiGateway');